import React from 'react';
import { Box, Tooltip } from '@mui/material';

export interface AirbnbBadgeProps {
  /** Tooltip text shown on hover. */
  tooltipTitle: string;
}

const AIRBNB_BADGE_SX = {
  display: 'inline-block' as const,
  px: 1.25,
  py: 0.375,
  borderRadius: 10,
  backgroundColor: '#FF5A5F',
  color: '#fff',
  fontSize: '0.75rem',
  fontWeight: 600,
  cursor: 'help' as const,
};

/**
 * Airbnb pill badge used next to section titles (e.g. "What Do Airbnb Listings Look Like", "Who Visits").
 * Same styling in all usages; tooltip text varies by section.
 */
const AirbnbBadge: React.FC<AirbnbBadgeProps> = ({ tooltipTitle }) => (
  <Tooltip title={tooltipTitle} placement="top">
    <Box component="span" sx={AIRBNB_BADGE_SX}>
      Airbnb
    </Box>
  </Tooltip>
);

export default AirbnbBadge;
